jQuery(function($) {
	'use strict';

	if ( $( 'body' ).hasClass( 'single-przepisy' )) {

	} else {

		var $images = $( '.recipe__images' );

		if ( 1 > $images.length ) {
			return;
		}

		$images.slick({
			arrows: false,
			dots: false,
			adaptiveHeight: true,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
			{
				breakpoint: 768,
				settings: 'unslick'
			}
			]
		});
	}
});

jQuery(function($) {
	'use strict';

	if ( $( 'body' ).hasClass( 'single-przepisy' )) {

	} else {
		var $images = $( '.recipe__images' ),
		photos = [],
		gallery;

		if ( 1 > $images.length ) {
			return;
		}

		$images.find( 'a' ).each( function ( index, elem ) {
			var link = $( elem ).attr( 'href' ),
			width = $( elem ).data( 'width' ),
			height = $( elem ).data( 'height' );
			var $elem = $( elem );

			if (!$elem.hasClass('no-gallery static-banner')) {
				photos.push({
					src: $elem.hasClass( 'no-gallery' ) ? $elem.data( 'photo-url' ) : $elem.attr( 'href' ),
					w: parseInt( $elem.data( 'width' ), 10 ),
					h: parseInt( $elem.data( 'height' ), 10 )
				});
			}
		}).not( '.no-gallery' ).on( 'click.delektujemy', function ( e ) {
			e.preventDefault();

			if( 768 <= window.innerWidth ) {
				gallery = new PhotoSwipe(
					$( '.pswp' )[0],
					PhotoSwipeUI_Default,
					photos,
					{
						index: $( this ).index()
					}
					);
				gallery.init();
			}
		});
	}
});
